import i18next from 'i18next'
import { localDayKey } from './groupByDay'

// Day keys are parsed manually: new Date('YYYY-MM-DD') would parse as UTC midnight
// and shift the day west of Greenwich.
const dayKeyToLocalDate = (dayKey: string): Date | null => {
  const [year, month, day] = dayKey.split('-').map(Number)
  if (!year || !month || !day) return null
  return new Date(year, month - 1, day)
}

export const formatDayHeader = (
  dayKey: string,
  language: string,
  now: Date = new Date()
): string => {
  const date = dayKeyToLocalDate(dayKey)
  if (!date) return dayKey

  const todayKey = localDayKey(now.toISOString())
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
  const yesterdayKey = localDayKey(yesterday.toISOString())

  if (dayKey === todayKey) return i18next.t('gallery.today')
  if (dayKey === yesterdayKey) return i18next.t('gallery.yesterday')

  return date.toLocaleDateString(language, { day: 'numeric', month: 'short', year: 'numeric' })
}
